import { IChannel } from '@/models/channel.model';

const getBlogPostsChannelsSlugs = (allChannels: IChannel[] | null, channelsToPublishIds: number[] = []) =>
  channelsToPublishIds?.reduce((acc, curr) => {
    if (!curr) return acc;

    const channelById = allChannels?.find(({ id }) => curr === id);

    if (channelById) {
      acc.push(channelById.slug);
    }

    return acc;
  }, [] as string[]);

export default getBlogPostsChannelsSlugs;
